/* eslint-disabled */
import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classNames from 'classnames';
import { Map } from 'immutable';
import Link from 'src/components/Link/Link';
import AuditList from './AuditList';
import Tabs from 'src/components/Tabs';

import { AppStateComponent } from 'src/AppState/AppState';
import { observer } from 'mobx-react';

@observer
class Audits extends AppStateComponent {
    static propTypes = {
        audits: ImmutablePropTypes.map,
        onCloseAuditRequest: PropTypes.func.isRequired,
        onQueryAuditsRequest: PropTypes.func.isRequired,
    };

    static defaultProps = {
        audits: Map(),
    };

    UNSAFE_componentWillMount() {
        this.loadAudit(this.props);
    }

    loadAudit = (props) => {
        const id = $appState.routerBackoffice.getValueString('audits');
        const filterTab = this.appState.customerTabState.filterTab;
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (!id) {
            return;
        }

        const audit = props.audits.find((o) => o === id);

        if (!audit) {
            const nid = id.split('_');
            const tags = nid.pop();
            const topics = nid.join('_');
            const isTagsArray = Array.isArray(tags);
            const tagNames = [
                'transactionType-deposit',
                'transactionType-withdrawal',
                'transactionType-manualAdjustment',
            ];
            const tagsFiltered = isTagsArray ? tags.filter((a) => !tagNames.includes(a) || a === filterTab) : [tags];

            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (filterTab !== null && filterTab !== undefined) {
                tagsFiltered.push(filterTab);
            }
            const tagsToQuery = tagsFiltered.filter((tag) => tag !== undefined && tag !== null && tag !== '');
            this.props.onQueryAuditsRequest(id, { topics: [topics], tags: tagsToQuery, filterName: filterTab });
        }
    };

    onCloseAudit(tab) {
        const { onCloseAuditRequest, audits } = this.props;
        onCloseAuditRequest(tab);
        const auditId = $appState.routerBackoffice.getValueString('audits');
        if (audits.size > 1) {
            this.onChange(auditId === tab ? Object.keys(audits.toJS())[0] : auditId);
        }
    }

    onChange(tab) {
        let path;
        if (tab) {
            path = `audits:${tab}`;
        } else {
            path = 'audits';
        }
        $appState.routerBackoffice.redirectToNamespace(path, {});
    }

    onMinimize(e) {
        e.preventDefault();
        $appState.routerBackoffice.setParamInNamespace('audits', {});
    }
    render() {
        const { audits } = this.props;
        const auditId = $appState.routerBackoffice.getValueString('audits');
        const className = classNames(['audits', { visible: auditId && audits.size > 0 }]);
        const elements = Object.keys(audits.toJS()).map((key) => {
            let label = audits.get('state') === 'ERROR' ? 'Error' : key;
            if (!label) {
                label = 'Loading...';
            }
            return (
                <AuditList
                    id={key}
                    key={key}
                    label={label}
                />
            );
        });

        return (
            <div className={className}>
                <div className='audits-content'>
                    <Link
                        route='audits'
                        className='audits-minimize'
                    />
                    <Tabs
                        className='tabs__vertical tabs__audits'
                        onClose={this.onCloseAudit.bind(this)}
                        allowClose={true}
                        onChange={this.onChange.bind(this)}
                        active={auditId}
                        tabsPlacement='audit-tabs'
                    >
                        {elements}
                    </Tabs>
                </div>
            </div>
        );
    }
}

export default Audits;
